export default "__VITE_ASSET__7v9iCHnE__"